module.exports = __webpack_public_path__ + "static/media/answerTop.afc9864f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerTop.png
// module id = 735
// module chunks = 0 1